function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
import map from 'lodash/map';
import intersection from 'lodash/intersection';
import { mapState, mapGetters } from 'vuex';
export default {
  computed: _objectSpread({}, mapState({
    elementsType: function elementsType(s) {
      return s.elements.type;
    },
    distance: function distance(s) {
      return s.elements.distance;
    }
  }), {}, mapGetters({
    resultType: 'api/formResultType'
  }), {
    currentResultElements: function currentResultElements() {
      return intersection(this.$ncsConfig.result[this.resultType].elements.types, this.$ncsConfig.elements.types);
    },
    currentResultDistances: function currentResultDistances() {
      return this.$ncsConfig.result[this.resultType].elements.distances;
    },
    currentResultOnlyDistances: function currentResultOnlyDistances() {
      return this.$ncsConfig.result[this.resultType].elements.onlyDistances;
    },
    options: function options() {
      var distances = map(this.currentResultElements, function (e) {
        return {
          type: e,
          distance: true
        };
      });
      var elements = map(this.currentResultElements, function (e) {
        return {
          type: e
        };
      });

      if (this.currentResultOnlyDistances) {
        return map(distances, function (e) {
          return "".concat(e.type).concat(e.distance ? '-distance' : '');
        });
      } else if (this.currentResultDistances) {
        return map([].concat(_toConsumableArray(elements), _toConsumableArray(distances)), function (e) {
          return "".concat(e.type).concat(e.distance ? '-distance' : '');
        });
      } else {
        return map(elements, function (e) {
          return e.type;
        });
      }
    },
    isDisabled: function isDisabled() {
      return this.options.length === 0;
    },
    selected: {
      get: function get() {
        return this.distance.type ? "".concat(this.elementsType, "-distance") : this.elementsType;
      },
      set: function set(v) {
        var _v$split = v.split('-'),
            _v$split2 = _slicedToArray(_v$split, 2),
            type = _v$split2[0],
            distance = _v$split2[1];

        this.$store.dispatch('elements/setSearchType', {
          type: type,
          distance: distance ? 'eq' : null
        });
      }
    }
  }),
  methods: {
    optionName: function optionName(option) {
      // option = this.currentResultOnlyDistances ? option.replace('-distance', '') : option
      return this.$t("elements.type.options.".concat(option));
    }
  }
};